// Supabase browser client (auth + client-side reads guarded by RLS).
//
// Uses the PUBLIC anon key — safe to expose to the browser because Row Level
// Security policies (see migrations/phase1_schema.sql) restrict what it can
// read/write. The serverless functions in /api keep using the service role
// key (SUPABASE_SECRET_KEY) and are unaffected by this file.
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// When the env vars are missing (e.g. local dev without a .env), the app must
// keep working exactly as before — auth UI simply hides itself.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured ? createClient(supabaseUrl, supabaseAnonKey) : null;
